"use client";

import { POLITICAL_STANCE_CATEGORIES } from "@/lib/guest-interest";

export const globalCustomVariables = {
    next_token_value: null as string | null | undefined, // Initialize as null
    prior_politician_chamber_query_info: "Currently Active",
    statement_next_token_value: null as string | null | undefined,
    GLOBAL_numberOfTimesPoliticiansClicked: 0 as number,
    Global_AuthState: 'identityPool' as AuthStateType
};

// This is how we store the user auth type in local memory
export type AuthStateType = "identityPool" | "userPool";
const STORAGE_KEY = "Global_AuthState";

// This is how the auth type is saved
export function saveAuthState(state: AuthStateType) {
  if (typeof window !== "undefined") {
    localStorage.setItem(STORAGE_KEY, state);
  }
}

// This is how the auth type is retrieved
export function getAuthState(): AuthStateType {
  if (typeof window === "undefined") return "identityPool";
  return (localStorage.getItem(STORAGE_KEY) as AuthStateType) ?? "identityPool";
}

export const global_years_in_congress = [
    'All',
    '2025-2026',
    '2023-2024',
    '2021-2022',
    '2019-2020',
    '2017-2018',
    '2015-2016',
    '2013-2014',
    '2011-2012',
    '2009-2010',
    '2007-2008',
    '2005-2006',
    '2003-2004',
    '2001-2002',
    '1999-2000',
    '1997-1998',
    '1995-1996']

// State Autocomplete option list:
export const Global_State_Autocomplete_Options = [
    { id: 'Alabama', label: 'Alabama' },
    { id: 'Alaska', label: 'Alaska' },
    { id: 'Arizona', label: 'Arizona' },
    { id: 'Arkansas', label: 'Arkansas' },
    { id: 'California', label: 'California' },
    { id: 'Colorado', label: 'Colorado' },
    { id: 'Connecticut', label: 'Connecticut' },
    { id: 'Delaware', label: 'Delaware' },
    { id: 'Florida', label: 'Florida' },
    { id: 'Georgia', label: 'Georgia' },
    { id: 'Hawaii', label: 'Hawaii' },
    { id: 'Idaho', label: 'Idaho' },
    { id: 'Illinois', label: 'Illinois' },
    { id: 'Indiana', label: 'Indiana' },
    { id: 'Iowa', label: 'Iowa' },
    { id: 'Kansas', label: 'Kansas' },
    { id: 'Kentucky', label: 'Kentucky' },
    { id: 'Louisiana', label: 'Louisiana' },
    { id: 'Maine', label: 'Maine' },
    { id: 'Maryland', label: 'Maryland' },
    { id: 'Massachusetts', label: 'Massachusetts' },
    { id: 'Michigan', label: 'Michigan' },
    { id: 'Minnesota', label: 'Minnesota' },
    { id: 'Mississippi', label: 'Mississippi' },
    { id: 'Missouri', label: 'Missouri' },
    { id: 'Montana', label: 'Montana' },
    { id: 'Nebraska', label: 'Nebraska' },
    { id: 'Nevada', label: 'Nevada' },
    { id: 'New Hampshire', label: 'New Hampshire' },
    { id: 'New Jersey', label: 'New Jersey' },
    { id: 'New Mexico', label: 'New Mexico' },
    { id: 'New York', label: 'New York' },
    { id: 'North Carolina', label: 'North Carolina' },
    { id: 'North Dakota', label: 'North Dakota' },
    { id: 'Ohio', label: 'Ohio' },
    { id: 'Oklahoma', label: 'Oklahoma' },
    { id: 'Oregon', label: 'Oregon' },
    { id: 'Pennsylvania', label: 'Pennsylvania' },
    { id: 'Rhode Island', label: 'Rhode Island' },
    { id: 'South Carolina', label: 'South Carolina' },
    { id: 'South Dakota', label: 'South Dakota' },
    { id: 'Tennessee', label: 'Tennessee' },
    { id: 'Texas', label: 'Texas' },
    { id: 'Utah', label: 'Utah' },
    { id: 'Vermont', label: 'Vermont' },
    { id: 'Virginia', label: 'Virginia' },
    { id: 'Washington', label: 'Washington' },
    { id: 'West Virginia', label: 'West Virginia' },
    { id: 'Wisconsin', label: 'Wisconsin' },
    { id: 'Wyoming', label: 'Wyoming' }
  ];

export const Comprehensive_Political_Stance_Categories: string[] = [
  ...POLITICAL_STANCE_CATEGORIES,
];

export const ISSUE_OPTIONS = Comprehensive_Political_Stance_Categories
  .filter((name) => name !== "All")
  .map((name) => ({ id: name, label: name }));

